module.exports = __webpack_public_path__ + "static/label-main-dc6a8a17e1b331f0d854abfb4057b5e5.png";